import { render, staticRenderFns } from "./RecordCount.vue?vue&type=template&id=7078f3e6&scoped=true&"
import script from "./RecordCount.vue?vue&type=script&lang=js&"
export * from "./RecordCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7078f3e6",
  null
  
)

export default component.exports